import { QuestionFieldFragment } from "@/generated/graphql";

export enum InteractionKind {
  Choice,
  TextEntry,
  Extended,
  Match,
  PositionObject,
  SocraticInteraction,
}

export function defaultBlankFieldInteractionKind() {
  return InteractionKind.TextEntry;
}

export function mapInteractionKind(
  graphQLkind:
    | "ChoiceInteraction"
    | "TextEntryInteraction"
    | "ExtendedInteraction"
    | "MatchInteraction"
    | "PositionObjectInteraction"
    | "SocraticInteraction"
): InteractionKind {
  switch (graphQLkind) {
    case "ChoiceInteraction":
      return InteractionKind.Choice;
    case "TextEntryInteraction":
      return InteractionKind.TextEntry;
    case "ExtendedInteraction":
      return InteractionKind.Extended;
    case "MatchInteraction":
      return InteractionKind.Match;
    case "PositionObjectInteraction":
      return InteractionKind.PositionObject;
    case "SocraticInteraction":
      return InteractionKind.SocraticInteraction;
  }
}

export function mapFieldInteractionKind(field: QuestionFieldFragment) {
  switch (field.interaction.__typename) {
    case "ChoiceInteraction":
      return InteractionKind.Choice;
    case "TextEntryInteraction":
      return InteractionKind.TextEntry;
    case "MatchInteraction":
      return InteractionKind.Match;
    case "PositionObjectInteraction":
      return InteractionKind.PositionObject;
    case "ExtendedInteraction":
    default:
      return InteractionKind.Extended;
  }
}
